import angular from 'angular';
import { MileageFormController } from './form-mileage.controller';

export const MileageForm = {
  selector: 'formMileage',
  controller: MileageFormController,
  bindings: {
    exit: '&',
    show: '=',
    vehicle: '<',
  },
  template: /* html */ `
    <form class="default-form backdrop-overlay-form pricing-form" ng-submit="$ctrl.formTransmission()" ng-if="$ctrl.show">
      <div class="box-wrap">
        <div class="boxL">
          <h3>Kilometerstand</h3>

          <div class="row">
            <div class="col-md-6 input-wrap" data-prefix="km">
              <input type="number" ng-model="$ctrl.updateData.mileage.total" placeholder="Kilometerstand" required min="0"
              step="1"/>
              <label>Kilometerstand</label>
            </div>
          </div>

          <div class="btn-wrap right">
            <button type="submit" class="btn-lvl1" ng-class="{'btn-sending': $ctrl.sending}" ng-disabled="$ctrl.sending">Daten speichern</button>
          </div>
        </div>
      </div>
    </form>
  `,
};

export default angular.module('directives.formMileage', [])
  .component(MileageForm.selector, MileageForm)
  .name;
